import styled from 'styled-components'
import RoomIcon from '@material-ui/icons/Room'

export const PaidLeaveMapIcon = styled(RoomIcon)`
  &&& {
    font-size: 2.2rem;
    position: relative;
    top: 0.5rem;
    margin-right: 0.2rem;
  }
`
